import { render, staticRenderFns } from "./ttshop_invoice.vue?vue&type=template&id=706e4f41&scoped=true&"
import script from "./ttshop_invoice.vue?vue&type=script&lang=js&"
export * from "./ttshop_invoice.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_invoice.vue?vue&type=style&index=0&id=706e4f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e4f41",
  null
  
)

export default component.exports